module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/ab156-caae26d94102e4cde5c0318771f8a722.jpg";